import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/credit_score_rules.svg'


const _withScopeId = n => (_pushScopeId("data-v-cf17e878"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5 pb-5 bg-white" }
const _hoisted_2 = { class: "py-3 px-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-weight-500 mb-1" }, "キャンセルの注意点", -1))
const _hoisted_4 = { class: "rule-list" }
const _hoisted_5 = { class: "text-weight-500 text-red text-size-14 mb-2 caution" }
const _hoisted_6 = { class: "text-weight-500 text-red text-size-14 caution" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-weight-500" }, "信用スコアのルール"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-mild mt-1" }, "\n        キャンセルの場合は、事業所側に連絡したタイミングに応じて、信用スコアが減少します。\n      ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "credit-score-rules-img"
  })
], -1))
const _hoisted_9 = { class: "py-2 px-3" }
const _hoisted_10 = { class: "rule-list" }
const _hoisted_11 = { class: "text-weight-500 text-red" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", { class: "rule-list-text text-mild" }, "\n          連絡なし欠勤：アカウントの一時利用停止\n        ", -1))
const _hoisted_13 = { class: "text-weight-500 text-yellow mt-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", { class: "rule-list-text text-mild" }, "\n          自己都合の遅刻・早退：スコア-2点\n        ", -1))
const _hoisted_15 = { class: "text-weight-500 text-green mt-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", { class: "rule-list-text text-mild mb-0" }, "\n          1回の勤務：信用スコア+1点\n        ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_FeatherIcon, {
            icon: "alert-triangle",
            size: "18",
            class: "caution-icon"
          }),
          _createTextVNode("同一事業所へ応募不可となる可能性があります\n        ")
        ]),
        _createTextVNode(),
        _createElementVNode("li", _hoisted_6, [
          _createVNode(_component_FeatherIcon, {
            icon: "alert-triangle",
            size: "18",
            class: "caution-icon"
          }),
          _createTextVNode("信用スコアが0ptになると一時的にお仕事へ応募不可となります\n        ")
        ])
      ])
    ]),
    _createTextVNode(),
    _hoisted_7,
    _createTextVNode(),
    _hoisted_8,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("dl", _hoisted_10, [
        _createElementVNode("dt", _hoisted_11, [
          _createVNode(_component_FeatherIcon, {
            icon: "alert-triangle",
            size: "18",
            class: "mr-2"
          }),
          _createTextVNode("無断欠勤\n        ")
        ]),
        _createTextVNode(),
        _hoisted_12,
        _createTextVNode(),
        _createElementVNode("dt", _hoisted_13, [
          _createVNode(_component_FeatherIcon, {
            icon: "alert-triangle",
            size: "18",
            class: "mr-2"
          }),
          _createTextVNode("遅刻\n        ")
        ]),
        _createTextVNode(),
        _hoisted_14,
        _createTextVNode(),
        _createElementVNode("dt", _hoisted_15, [
          _createVNode(_component_FeatherIcon, {
            icon: "battery-charging",
            size: "18",
            class: "mr-2"
          }),
          _createTextVNode("復活制度\n        ")
        ]),
        _createTextVNode(),
        _hoisted_16
      ])
    ]),
    _createTextVNode(),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}